"use client"

import styles from "./Footer.module.css"

import footerImg from "../../assets/images/footer-whatasapp-doctors-2.png"
import logo from "../../assets/images/estaverde-logo-2.png"
import wpIcon from "../../assets/images/wp-icon.png"
import instaIcon from "../../assets/images/insta-logo.png"
import { useRef, useState, useEffect } from "react"
import emailjs from '@emailjs/browser'
import { countryCodes } from "../../utils/countryCodes"

export default function Footer() {
  const formRef = useRef(null)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [isSending, setIsSending] = useState(false)

  // Ülke kodu seçici durumu (FixedFormIcon mantığını yeniden kullanır)
  const [selectedCountry, setSelectedCountry] = useState(() => (countryCodes.find(c => c.name === 'United States') || countryCodes[0]))
  const [phone, setPhone] = useState("")
  const [isCodeOpen, setIsCodeOpen] = useState(false)
  const codeWrapRef = useRef(null)

  // Dışa tıklamada ülke kodu açılır menüsünü kapat
  useEffect(() => {
    if (!isCodeOpen) return
    const onClickOutside = (e) => {
      const el = codeWrapRef.current
      if (el && !el.contains(e.target)) {
        setIsCodeOpen(false)
      }
    }
    document.addEventListener('mousedown', onClickOutside)
    document.addEventListener('touchstart', onClickOutside)
    return () => {
      document.removeEventListener('mousedown', onClickOutside)
      document.removeEventListener('touchstart', onClickOutside)
    }
  }, [isCodeOpen])

  const sendEmail = (e) => {
    e.preventDefault()
    setIsSending(true)
    const fd = new FormData(formRef.current)
    const params = {
      user_name: fd.get('user_name') || '',
      user_email: fd.get('user_email') || '',
      message: fd.get('message') || '',
      user_phone: fd.get('user_phone') || '',
      country_code: fd.get('country_code') || (selectedCountry?.dial_code || ''),
      user_phone_full: `${fd.get('country_code') || (selectedCountry?.dial_code || '')} ${fd.get('user_phone') || ''}`.trim(),
    }

    emailjs
      .send(
        'service_57xto7k',
        'template_ivxg7n9',
        params,
        { publicKey: 'OPDDEgsIGDGJBTjaz' }
      )
      .then(
        () => {
          setIsSubmitted(true)
          setIsSending(false)
          formRef.current && formRef.current.reset()
          setPhone('')
        },
        (error) => {
          console.error('Email sending failed:', error)
          setIsSending(false)
          alert('There was an error sending your message. Please try again in a short while.')
        }
      )
  }

  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.footerGrid}`}>
        {/* Sol sütun */}
        <div className={styles.leftCol}>
          {/* Sol üst: gradyan + form */}
          <div className={styles.leftTop}>
            <div className={styles.consultText}>GET FREE
              <br />
              CONSULTANCY
            </div>
            {!isSubmitted ? (
              <form ref={formRef} className={styles.consultForm} onSubmit={sendEmail}>
                <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 2.8fr', gap: 6 }}>
                  <div className={styles.codeSelectWrap} ref={codeWrapRef}>
                    <button
                      type="button"
                      className={styles.codeSelectTrigger}
                      onClick={() => setIsCodeOpen(o => !o)}
                      aria-haspopup="listbox"
                      aria-expanded={isCodeOpen}
                    >
                      <span className={styles.codeLabel}>{selectedCountry?.name || 'United States'}</span>
                      <span className={styles.codeValue}>{selectedCountry?.dial_code || '+1'}</span>
                    </button>
                    {isCodeOpen && (
                      <ul className={styles.codeList} role="listbox">
                        {(() => {
                          const pinnedNames = ['United States','Russian Federation','United Kingdom','Turkey']
                          const pinned = countryCodes.filter(c => pinnedNames.includes(c.name))
                          const rest = countryCodes
                            .filter(c => !pinnedNames.includes(c.name))
                            .sort((a, b) => a.name.localeCompare(b.name))
                          return (
                            <>
                              {pinned.map((c) => (
                                <li
                                  key={'pinned-' + c.code + c.dial_code}
                                  role="option"
                                  className={styles.codeItem}
                                  onClick={() => { setSelectedCountry(c); setIsCodeOpen(false) }}
                                >
                                  <span className={styles.codeLabel}>{c.name}</span>
                                  <span className={styles.codeValue}>{c.dial_code}</span>
                                </li>
                              ))}
                              <li className={styles.codeDivider} aria-hidden="true" />
                              {rest.map((c) => (
                                <li
                                  key={c.code + c.dial_code}
                                  role="option"
                                  className={styles.codeItem}
                                  onClick={() => { setSelectedCountry(c); setIsCodeOpen(false) }}
                                >
                                  <span className={styles.codeLabel}>{c.name}</span>
                                  <span className={styles.codeValue}>{c.dial_code}</span>
                                </li>
                              ))}
                            </>
                          )
                        })()}
                      </ul>
                    )}
                    <input type="hidden" name="country_code" value={selectedCountry?.dial_code || ''} />
                  </div>
                  <input
                    type="tel"
                    placeholder="Phone Number"
                    name="user_phone"
                    required
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>
                <input type="hidden" name="user_phone_full" value={`${selectedCountry?.dial_code || ''} ${phone}`} />
                <input type="text" placeholder="Full Name" name="user_name" required />
                <input type="email" placeholder="Email Address" name="user_email" required />
                <button className={styles.consultBtn} type="submit" disabled={isSending}>
                  {isSending ? 'Sending...' : 'GET FREE CONSULTATION'}
                </button>
              </form>
            ) : (
              <div style={{ textAlign: 'center', padding: '8px 0 4px' }}>
                <div style={{ marginBottom: 12 }}>
                  <svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="32" fill="#13A672"/><path d="M20 32l8 8 14-14" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </div>
                <h3 style={{ margin: 0, color: '#13A672' }}>Thank you!</h3>
                <p style={{ margin: '6px 0 0', lineHeight: 1.5 }}>
                  Your request has been received successfully.<br />
                  Our medical consultants will contact you shortly to schedule your free consultation.
                </p>
              </div>
            )}
          </div>

          {/* Sol alt: gri menü */}
          <div className={styles.leftBottom}>
            <div className={styles.menuCols}>
              <div className={styles.menuGroup}>
                <div className={`${styles.menuTitle} ${styles.navyTitle}`}>Hair Transplant</div>
                <nav className={`${styles.menuLinks} ${styles.hairLinks}`}>
                  <a href="/dhi-hair-transplant">DHI Hair Transplant</a>
                  <a href="/sapphire-fue-hair-transplant">Sapphire FUE</a>
                  <a href="/autologous-micrograft">Autologous Micrograft</a>
                </nav>
              </div>
              <div className={`${styles.menuGroup} ${styles.plasticGroup}`}>
                <div className={`${styles.menuTitle} ${styles.navyTitle}`}>Plastic Surgeries</div>
                <nav className={styles.menuLinks} style={{ marginTop: "8px" }}>
                  <a href="/rhinoplasty">Rhinoplasty</a>
                </nav>
              </div>
            </div>
          </div>
        </div>

        {/* Sağ sütun */}
        <div className={styles.rightCol}>
          {/* Sağ üst: metin ve görsel içeren beyaz alan */}
          <div className={styles.rightTop}>
            <h4 className={styles.rightTopTitle}>
              <span className={styles.titleGreen}>A SHARED PATH</span>
              <br />
              <span className={styles.titleTurquoise}>TO LIFELONG WELL-BEING</span>
            </h4>
            <p>
            Our guiding principle is simple: to be your trusted partner in health, focused entirely on your lifelong happiness and quality of life.
            </p>
            <div className={styles.footerImageSection}>
              <a href="https://wa.me/905337674950" target="_blank" rel="noreferrer" style={{ display: 'block', cursor: 'pointer' }}>
                <img src={footerImg} alt="Clinic Team" className={styles.footerDoctorsImg} />
              </a>
            </div>
          </div>

          {/* Sağ alt: ofisler + logo/sosyal medya */}
          <div className={styles.rightBottom}>
            <div className={styles.offices}>
              <div>
                <h5>Turkey Office</h5>
                <p>Merdivenköy Mah. Nur Sokak No:1/1 Kat:12 D:115 Business İstanbul  Kadiköy / İstanbul / Turkey</p>
                <p><strong>Phone</strong><br/><a href="https://wa.me/905337674950" target="_blank" rel="noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}><span style={{ fontWeight: '600' }}>+90</span> 533 767 49 50</a></p>
                <p><strong>E-Mail</strong><br/><a href="mailto:info@estaverde.com" style={{ color: 'inherit', textDecoration: 'none' }}>info@estaverde.com</a></p>
              </div>
            </div>
            <div className={styles.brandRow}>
              <img src={logo} alt="EstaVerde Clinic" className={styles.brandLogo} />
              <div className={styles.socials}>
                <a href="https://wa.me/905337674950" target="_blank" rel="noreferrer" aria-label="WhatsApp">
                  <img src={wpIcon} alt="WhatsApp" className={styles.socialIcon} />
                </a>
                <a href="https://instagram.com/estaverde_clinic" target="_blank" rel="noreferrer" aria-label="Instagram">
                  <img src={instaIcon} alt="Instagram" className={styles.socialIcon} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.copy}>©{new Date().getFullYear()} EstaVerde Clinic — All rights reserved.</div>
    </footer>
  )
}
